import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { defaultNS, NAMESPACES, resources } from './resources';

export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

// Local-storage key holding the user's language choice. v1 persists locally
// only; profile-level persistence is a deliberate follow-up (see the i18n PRD).
export const LANGUAGE_STORAGE_KEY = 'fleetster-language';

// English is the product default AND the fallback: a first-time visitor gets
// English regardless of browser language, because detection reads only the
// stored choice — nothing is inferred from `navigator`. The switcher's
// `changeLanguage` writes the choice back to localStorage (`caches`), so it
// survives reloads. Because every locale is a complete, type-checked dictionary
// (de is typed against en), the fallback never actually fills a gap at runtime.
void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: [...defaultNS],
    ns: [...NAMESPACES],
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: {
      // React already escapes interpolated values.
      escapeValue: false,
    },
    // The dictionary ships inline and is never lazy-loaded, so translations are
    // ready on first render — no Suspense boundary required.
    react: { useSuspense: false },
  });

export default i18n;
